import styled from 'styled-components'
import { getBreakpoint } from '../styles/getBreakpoint'

export const Container = styled.div`
  box-sizing: border-box;
  margin: 0 auto;
  max-width: 100%;
  ${getBreakpoint(0)`
		max-width: 720px;
	`} ${getBreakpoint(1)`
		max-width: 992px;
	`};
`



// WEBPACK FOOTER //
// ./src/components/Container.tsx